import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { fromDateOnlyString } from '../../core/date';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DeliveryService {
	private httpClient = inject(HttpClient);

	getLastDeliveryDate(subscriberKey: number, hierarchyNodeKeys: number[]) : Observable<Date | null> {
		const body = {
			hierarchyNodeKeys
		};

		return this.httpClient.post<string>(`api/subscriber/${subscriberKey}/deliveries/last-delivery-date`, body)
			.pipe(map(fromDateOnlyString));
	}
}
